function DDUFooterTC_CUT({value}) {
    return (
        <div class="relative flex items-center justify-center border-[#63aafe] border-[2px] rounded-[10px] text-[#63aafe]">
            <p class={`${value["pit-limiter"] === 1 ? "bg-[#0743c2]" : "bg-[#0a0f14]"} absolute top-[-13px] text-[12px] px-3 py-1 uppercase font-bold`}>TC CUT</p>
            <h1 class="text-[40px] font-bold">{value["tc-cut"]}</h1>
        </div>
    );
}

export default DDUFooterTC_CUT;